import SimilarTitlesApi from '../api/SimilarTitlesApi';
import SimilarTitlesConstants from '../constants/SimilarTitlesConstants';

function addSimilarTitle(metadataId, similarMetadataId, postSuccess) {
  return {
    metadataId,
    similarMetadataId,
    postSuccess,
    types: [
      SimilarTitlesConstants.ADD_SIMILAR_TITLES_REQUEST,
      SimilarTitlesConstants.ADD_SIMILAR_TITLES_SUCCESS,
      SimilarTitlesConstants.ADD_SIMILAR_TITLES_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => SimilarTitlesApi.addSimilarTitle({
      metadataId,
      similarMetadataId,
      userId: state.getIn(['auth', 'currentUserId'])
    }, client)
  };
}

function removeSimilarTitle(metadataId, similarMetadataId) {
  return {
    metadataId,
    similarMetadataId,
    types: [
      SimilarTitlesConstants.REMOVE_SIMILAR_TITLES_REQUEST,
      SimilarTitlesConstants.REMOVE_SIMILAR_TITLES_SUCCESS,
      SimilarTitlesConstants.REMOVE_SIMILAR_TITLES_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => SimilarTitlesApi.removeSimilarTitle({
      similarMetadataId,
      userId: state.getIn(['auth', 'currentUserId'])
    }, client),
    apiSuccess: () => ({
      deletedEntities: [`ugc.similarTitles.${similarMetadataId}`]
    })
  };
}

export default {
  addSimilarTitle,
  removeSimilarTitle
};



// WEBPACK FOOTER //
// ./app/actions/SimilarTitlesActions.js